module.exports = __webpack_public_path__ + "static/1-4b57e94501c69c6e2a0e8f20f3b64bb3.jpg";